module.exports = __webpack_public_path__ + "img/01125797000205.83ee1e58.png";